import React, { useState } from "react";
import Sidebar from "./components/Sidebar";
import InvestigationList from "./components/InvestigationList";

function App() {
    const [selectedDepartment, setSelectedDepartment] = useState(null);

    return (
        <div style={{ display: "flex" }}>
            <Sidebar onSelectDepartment={setSelectedDepartment} selectedDepartment={selectedDepartment} />
            <div style={{ flex: 1, padding: "20px" }}>
            <InvestigationList invdeptid={selectedDepartment} />
            </div>
        </div>
    );
}

export default App;

